<section class="case-context-route-host">
  <phms-case-context-page
    *ngIf="!isUnavailable && incarceratedPersonId != null"
    [incarceratedPersonId]="incarceratedPersonId"
  ></phms-case-context-page>

  <div *ngIf="isUnavailable" class="case-context-route-host__unavailable" role="alert">
    <h2 class="case-context-route-host__unavailable-title">Case context unavailable</h2>
    <p class="case-context-route-host__unavailable-message">{{ unavailableMessage }}</p>
  </div>
</section>
